import { coerceConfidence, formatConfidence } from '../chunk-AYTSZXPQ.js';
import '../chunk-PKV65JOA.js';
import '../chunk-7AG7YCLV.js';
import { expandContractLinks, isCandidateContractReference, contractObservations, RelatedAddressLinkRowSchema, GraphEdgeSchema, RelationshipActivitySchema } from '../chunk-SAVBWA64.js';
export { ContractObservationSchema, ContractRelationshipOptionsSchema, contractObservations, contractPredicateLabel, expandContractLinks, hasContractReferenceDirection, isCandidateContractReference } from '../chunk-SAVBWA64.js';
import '../chunk-6XJKVJAV.js';
import '../chunk-G52JO5LR.js';
import '../chunk-ML7ISDRN.js';
import '../chunk-BJ3WKLB6.js';
import '../chunk-INX63VAT.js';
import { keys } from '../chunk-JYWBNGOD.js';
import '../chunk-WVLHT3DL.js';
import '../chunk-MNCO7S77.js';
import '../chunk-OKU57CF6.js';
import '../chunk-XR6TNFQL.js';
import { unwrapData } from '../chunk-HIWBYL4O.js';
import '../chunk-ZL25WV32.js';
import '../chunk-RMLZ5HCT.js';
import '../chunk-BRBMP7SU.js';
import '../chunk-MZH5OJVQ.js';
import '../chunk-5WIUKZF6.js';
import '../chunk-HCZGW64N.js';
import '../chunk-DCK4H5YA.js';
import '../chunk-LQ53YLJL.js';
import '../chunk-BFUJOKOR.js';
import '../chunk-EE4CQDCZ.js';
import '../chunk-6B5KO6TH.js';
import '../chunk-3QN2VZ56.js';
import '../chunk-LNDNXOJP.js';
import '../chunk-LVCDLPYA.js';
import '../chunk-UEXNJL5R.js';
import '../chunk-RFBTC3N2.js';
import { parseAddressReference } from '../chunk-VJ3UT4VV.js';
import '../chunk-O2TUCS6S.js';
import { normalizeAddress, isValidAddress } from '../chunk-DJI3ECST.js';
import '../chunk-IMD7EVVL.js';
import { toCanonicalChainId, chainDisplayName } from '../chunk-WI4JRSIJ.js';
import '../chunk-GPJ572YS.js';
import '../chunk-N7SZ66QO.js';
import '../chunk-LD6PO66H.js';
import '../chunk-AHISJLEK.js';
import '../chunk-QXYP3KHC.js';
import '../chunk-O5TCTRWM.js';
import '../chunk-O3OIBNP7.js';
import '../chunk-PZ5AY32C.js';
import { z } from 'zod';

// src/related-addresses/model.ts
var CLUSTER_RUN_STATUSES = [
  "queued",
  "running",
  "succeeded",
  "partial",
  "failed"
];
var TERMINAL_CLUSTER_RUN_STATUSES = /* @__PURE__ */ new Set(["succeeded", "partial", "failed"]);
function isTerminalClusterRunStatus(status) {
  return TERMINAL_CLUSTER_RUN_STATUSES.has(status);
}
function clusterRunAnswered(status) {
  return status === "succeeded" || status === "partial";
}
function clusterRunReplacesAnswer(status) {
  return status === "succeeded";
}
var CLUSTER_RUN_STATUS_LABELS = {
  queued: "Queued",
  running: "Analysing",
  succeeded: "Done",
  partial: "Done (partial)",
  failed: "Failed"
};
var CLUSTER_RUN_TRIGGERS = [
  "adhoc",
  "pipeline",
  "exploration",
  "scheduled",
  "backfill"
];
var CLUSTER_MEMBER_ROLES = ["seed", "member"];
function isLiveActor(actor) {
  return Boolean(actor) && !actor?.merged_into;
}
var DEFAULT_CLUSTER_MAX_HOPS = 2;
var CLUSTER_MAX_HOPS_CEILING = 4;
var CLUSTER_RUN_REUSE_WINDOW_SECONDS = 15 * 60;
var CLUSTER_DEFAULT_PAGE_LIMIT = 50;
var CLUSTER_MAX_PAGE_LIMIT = 200;
var RELATED_ADDRESS_SCOPES = {
  list: "related-addresses:list",
  show: "related-addresses:show",
  create: "related-addresses:create"
};
var CLUSTER_ANALYSIS_PROFILES = ["standard", "deep"];
var CLUSTER_ANALYSIS_PROFILE_LABELS = {
  standard: "Standard analysis",
  deep: "Deep analysis"
};
function clusterAnalysisProfileLabel(profile) {
  return profile && profile in CLUSTER_ANALYSIS_PROFILE_LABELS ? CLUSTER_ANALYSIS_PROFILE_LABELS[profile] : null;
}
function viewCorrections(view) {
  if (!view) return [];
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const correction of [
    ...view.identity?.corrections ?? [],
    ...view.snapshot?.corrections ?? []
  ]) {
    if (!correction?.override_sk || seen.has(correction.override_sk)) continue;
    seen.add(correction.override_sk);
    out.push(correction);
  }
  return out;
}
var MAX_IDENTITY_ACCOUNTS = 100;
var MAX_LOOKUP_ACCOUNTS = 50;
var LOOKUP_CHUNK_ACCOUNTS = 10;
var LOOKUP_CHUNK_CONCURRENCY = 3;
var MANUAL_LINK_KIND = "manual_link";
function mergeRoleCompositions(compositions) {
  const present = compositions.filter((c) => Boolean(c));
  if (present.length === 0) return null;
  if (present.length === 1) return present[0];
  const byRole = /* @__PURE__ */ new Map();
  for (const composition of present) {
    for (const group of composition.roles) {
      const existing = byRole.get(group.role) ?? { label: group.label, holders: /* @__PURE__ */ new Map() };
      for (const holder of group.holders) {
        const seen = existing.holders.get(holder.node_id);
        existing.holders.set(
          holder.node_id,
          seen ? {
            ...seen,
            // The strongest claim, not an average: a member with one weak
            // link and one strong one is described by the strong one.
            confidence: Math.max(seen.confidence, holder.confidence),
            is_seed: seen.is_seed || holder.is_seed,
            evidence: [...seen.evidence, ...holder.evidence]
          } : holder
        );
      }
      byRole.set(group.role, existing);
    }
  }
  const members = /* @__PURE__ */ new Set();
  const unroled = /* @__PURE__ */ new Set();
  for (const composition of present) {
    for (const node of composition.unroled) unroled.add(node);
    for (const group of composition.roles) {
      for (const holder of group.holders) members.add(holder.node_id);
    }
  }
  for (const node of members) unroled.delete(node);
  const roles = [...byRole.entries()].map(([role, entry]) => {
    const holders = [...entry.holders.values()].sort((a, b) => b.confidence - a.confidence);
    return { role, label: entry.label, holder_count: holders.length, holders };
  }).sort((a, b) => b.holder_count - a.holder_count || a.role.localeCompare(b.role));
  const first = present[0];
  return {
    // No single cluster owns this, and inventing an id would let a caller cache
    // it as though one did.
    cluster_id: "",
    subject_kind: "merged",
    seed_node_id: first.seed_node_id,
    as_of: Math.max(...present.map((c) => c.as_of)),
    window: first.window,
    member_count: members.size + unroled.size,
    members_read: present.reduce((total, c) => total + c.members_read, 0),
    links_read: present.reduce((total, c) => total + c.links_read, 0),
    truncated: present.some((c) => c.truncated),
    roles,
    unroled: [...unroled]
  };
}
function addressClusterState(lookup) {
  if (!lookup) return "never-analysed";
  if (lookup.clustered && (lookup.actor || lookup.cluster)) return "clustered";
  if (lookup.view?.identity?.excluded) return "excluded-by-correction";
  if (lookup.view?.held_out) return "held-out-by-correction";
  if (lookup.last_run?.seed_excluded_by) return "shared-infrastructure";
  if (lookup.last_run?.status === "queued" || lookup.last_run?.status === "running") return "analysing";
  return lookup.last_run ? "stands-alone" : "never-analysed";
}
function isIdentityClaim(link) {
  if (link.kind === "contract_state_reference" || link.kind === "likely_common_control" || link.rejection_reason || link.same_actor === false) return false;
  const flagged = link.identity_claim;
  if (typeof flagged === "boolean") return flagged;
  return link.deterministic === true && link.same_actor === true && Boolean(link.cluster_id);
}
function isAdmittedLink(link) {
  if (link.kind === "contract_state_reference") return false;
  return !link.rejection_reason && Boolean(link.cluster_id);
}
function splitLinksByClaim(links) {
  const sameActor = [];
  const related = [];
  const rejected = [];
  for (const link of links ?? []) {
    (link.rejection_reason ? rejected : isIdentityClaim(link) ? sameActor : related).push(link);
  }
  return { sameActor, related, rejected };
}
function linkCounterpart(link, nodeId) {
  return link.a_id === nodeId ? link.b_id : link.a_id;
}
var CLUSTER_OVERRIDE_ACTIONS = ["exclude", "pin", "detach"];
var CLUSTER_OVERRIDE_SCOPES = [
  "system",
  "customer",
  "org",
  "tenant",
  "team",
  "user"
];
var CLUSTER_OVERRIDE_AUTHORING_SCOPES = [
  "user",
  "team",
  "tenant",
  "org",
  "customer"
];
function isAppliedOverrideScope(scope) {
  return CLUSTER_OVERRIDE_SCOPES.includes(scope);
}
var CLUSTER_OVERRIDE_SCOPE_LABELS = {
  system: "Everyone",
  customer: "My customer",
  org: "My org",
  tenant: "My tenant",
  team: "My team",
  user: "Only me"
};
var CLUSTER_PEER_OVERRIDE_ACTIONS = /* @__PURE__ */ new Set(["pin", "detach"]);
function overrideNeedsPeer(action) {
  return CLUSTER_PEER_OVERRIDE_ACTIONS.has(action);
}
function overrideNeedsCluster(action) {
  return overrideNeedsPeer(action);
}
var CLUSTER_OVERRIDE_ACTION_LABELS = {
  exclude: "Never cluster",
  pin: "Pin to identity",
  detach: "Remove from identity"
};
var CLUSTER_OVERRIDE_SCOPE_RANK = {
  system: 30,
  customer: 40,
  org: 50,
  tenant: 60,
  team: 65,
  user: 70
};
function effectiveOverride(overrides, nodeId) {
  let best;
  for (const row of overrides) {
    if (row.node_id !== nodeId || row.enabled === false || !isAppliedOverrideScope(row.scope)) continue;
    if (!best) {
      best = row;
      continue;
    }
    const rank = (CLUSTER_OVERRIDE_SCOPE_RANK[row.scope] ?? 0) - (CLUSTER_OVERRIDE_SCOPE_RANK[best.scope] ?? 0);
    const newer = (row.updated_at ?? 0) - (best.updated_at ?? 0);
    if (rank > 0 || rank === 0 && (newer > 0 || newer === 0 && row.id > best.id)) best = row;
  }
  return best;
}

// src/related-addresses/api.ts
function encodePathSegment(value) {
  return encodeURIComponent(value).replace(
    /[!'()*]/g,
    (char) => `%${char.charCodeAt(0).toString(16).toUpperCase()}`
  );
}
function normalizeLookup(res) {
  return {
    node_id: res.node_id ?? "",
    clustered: Boolean(res.clustered && (res.actor || res.cluster)),
    actor: res.actor ?? null,
    cluster: res.cluster ?? null,
    last_run: res.last_run ?? null,
    newer_run: res.newer_run ?? null,
    active_run: res.active_run ?? null,
    answer_run: res.answer_run ?? null,
    other_clusters: Array.isArray(res.other_clusters) ? res.other_clusters : [],
    members: Array.isArray(res.members) ? res.members : [],
    actor_members: Array.isArray(res.actor_members) ? res.actor_members : [],
    roles: normalizeRoles(res.roles),
    coverage: res.coverage ?? null,
    profile: profileOf(res.profile),
    analysis: analysisOf(res.analysis),
    view: normalizeView(res.view)
  };
}
function profileOf(value) {
  return typeof value === "string" && value ? value : null;
}
function analysisOf(value) {
  return value === "shared" || value === "private" ? value : null;
}
function nodeIds(value) {
  return Array.isArray(value) ? value.filter((id) => typeof id === "string") : [];
}
function corrections(value) {
  return Array.isArray(value) ? value.filter(
    (row) => Boolean(row) && typeof row.override_sk === "string"
  ).map((row) => ({ ...row, peer_node_id: row.peer_node_id ?? null })) : [];
}
function normalizeView(value) {
  if (!value || typeof value !== "object") return null;
  const raw = value;
  const identity = raw.identity ?? {};
  const snapshot = raw.snapshot && typeof raw.snapshot === "object" ? raw.snapshot : null;
  return {
    corrected: Boolean(raw.corrected),
    held_out: raw.held_out === true,
    identity: {
      corrected: Boolean(identity.corrected),
      // Defaults TRUE: `exact: false` qualifies an answer, and a misshaped
      // reply must not invent a qualification nobody sent.
      exact: identity.exact !== false,
      excluded: identity.excluded === true,
      removed: nodeIds(identity.removed),
      added: nodeIds(identity.added),
      corrections: corrections(identity.corrections)
    },
    ...snapshot ? {
      snapshot: {
        corrected: Boolean(snapshot.corrected),
        removed: nodeIds(snapshot.removed),
        added: nodeIds(snapshot.added),
        corrections: corrections(snapshot.corrections)
      }
    } : {}
  };
}
function clampLimit(limit) {
  if (typeof limit !== "number" || !Number.isFinite(limit)) return CLUSTER_DEFAULT_PAGE_LIMIT;
  return Math.min(Math.max(Math.trunc(limit), 1), CLUSTER_MAX_PAGE_LIMIT);
}
function rolesQuery(query) {
  if (!query?.include_roles) {
    return query?.include_coverage ? { include_coverage: true } : {};
  }
  const q = { include_roles: true };
  if (query.include_coverage) q.include_coverage = true;
  if (typeof query.since === "number") q.since = Math.trunc(query.since);
  if (typeof query.until === "number") q.until = Math.trunc(query.until);
  return q;
}
function normalizeRoles(roles) {
  if (!roles || typeof roles !== "object") return null;
  const raw = roles;
  return {
    cluster_id: raw.cluster_id ?? "",
    subject_kind: raw.subject_kind ?? "cluster",
    seed_node_id: raw.seed_node_id ?? "",
    as_of: raw.as_of ?? 0,
    window: raw.window ?? { since: null, until: null, basis: "observed" },
    member_count: raw.member_count ?? 0,
    members_read: raw.members_read ?? 0,
    links_read: raw.links_read ?? 0,
    // Defaults TRUE when the reply is misshaped, for the same reason `complete`
    // defaults false below: presenting part of an actor as the whole of it is
    // the one failure this panel must not have.
    truncated: raw.truncated ?? true,
    roles: Array.isArray(raw.roles) ? raw.roles : [],
    unroled: Array.isArray(raw.unroled) ? raw.unroled : []
  };
}
function createRelatedAddressesApi(client, options = {}) {
  const base = (options.basePath ?? "/related-addresses").replace(/\/+$/, "");
  const clusters = `${base}/clusters`;
  const runs = `${base}/cluster-runs`;
  const overrides = `${base}/cluster-overrides`;
  const lookup = (chain, address, tail) => `${base}/addresses/${encodeURIComponent(chain)}/${encodeURIComponent(address)}/${tail}`;
  const api = {
    async getCluster(clusterId, query, signal) {
      const q = {
        limit: clampLimit(query?.limit),
        ...rolesQuery(query)
      };
      if (query?.cursor) q.cursor = query.cursor;
      const res = unwrapData(
        await client.get(`${clusters}/${encodeURIComponent(clusterId)}`, {
          query: q,
          signal,
          cacheTtlMs: 0
        })
      );
      if (!res?.cluster) return null;
      return {
        cluster: res.cluster,
        actor: res.actor ?? null,
        members: Array.isArray(res.members) ? res.members : [],
        links: Array.isArray(res.links) ? res.links : [],
        next_cursor: res.next_cursor ?? null,
        roles: normalizeRoles(res.roles),
        profile: profileOf(res.profile),
        analysis: analysisOf(res.analysis),
        view: normalizeView(res.view)
      };
    },
    async identitiesFor(accounts, signal) {
      const wanted = [...new Set(accounts.filter(Boolean))];
      const out = [];
      for (let start = 0; start < wanted.length; start += MAX_IDENTITY_ACCOUNTS) {
        const res = unwrapData(
          await client.get(`${base}/identities`, {
            query: { accounts: wanted.slice(start, start + MAX_IDENTITY_ACCOUNTS).join(",") },
            signal
          })
        );
        if (!res || !Array.isArray(res.items)) {
          throw new Error("The service did not return a valid identities lookup.");
        }
        for (const raw of res.items) {
          const item = raw;
          if (!item || typeof item.account !== "string" || typeof item.node_id !== "string") continue;
          out.push({
            account: item.account,
            node_id: item.node_id,
            actor: item.actor ?? null,
            corrected: item.corrected === true,
            held_out: item.held_out === true
          });
        }
      }
      return out;
    },
    async clusterLookupsFor(accounts, signal) {
      const wanted = [...new Set(accounts.filter(Boolean))];
      const chunks = [];
      for (let start = 0; start < wanted.length; start += LOOKUP_CHUNK_ACCOUNTS) {
        chunks.push(wanted.slice(start, start + LOOKUP_CHUNK_ACCOUNTS));
      }
      const readChunk = async (chunk) => {
        const out = [];
        const res = unwrapData(
          await client.get(`${base}/address-clusters`, {
            query: { accounts: chunk.join(",") },
            signal,
            cacheTtlMs: 0
          })
        );
        if (!res || !Array.isArray(res.items) || res.items.length !== chunk.length) {
          throw new Error("The service did not return a valid address-clusters lookup.");
        }
        res.items.forEach((raw, i) => {
          const item = raw ?? {};
          const requested = chunk[i];
          const failed2 = Boolean(item.error) || typeof item.node_id !== "string";
          out.push({
            ...normalizeLookup(item),
            account: typeof item.account === "string" ? item.account : requested,
            requested,
            ...failed2 ? { error: "lookup_failed" } : {}
          });
        });
        return out;
      };
      const results = new Array(chunks.length);
      let next = 0;
      const worker = async () => {
        while (next < chunks.length) {
          const at = next++;
          try {
            results[at] = await readChunk(chunks[at]);
          } catch (err) {
            if (signal?.aborted) throw err;
            results[at] = { failed: err };
          }
        }
      };
      await Promise.all(Array.from({ length: Math.min(LOOKUP_CHUNK_CONCURRENCY, chunks.length) }, worker));
      const failed = results.filter((r) => !Array.isArray(r));
      if (failed.length > 0 && failed.length === chunks.length) throw failed[0].failed;
      return results.flatMap(
        (r, i) => Array.isArray(r) ? r : chunks[i].map((requested) => ({
          ...normalizeLookup({}),
          account: requested,
          requested,
          error: "lookup_failed"
        }))
      );
    },
    async clusterForAddress(chain, address, query, signal) {
      const q = { ...rolesQuery(query) };
      if (query?.include_members) q.include_members = true;
      if (typeof query?.limit === "number") q.limit = clampLimit(query.limit);
      const res = unwrapData(
        await client.get(lookup(chain, address, "cluster"), {
          query: q,
          signal,
          cacheTtlMs: 0
        })
      );
      if (!res || typeof res.node_id !== "string" || !res.node_id || typeof res.clustered !== "boolean") {
        throw new Error("The service did not return a valid address-cluster lookup.");
      }
      return normalizeLookup(res);
    },
    async linksForAddress(chain, address, query, signal) {
      const q = { limit: clampLimit(query?.limit) };
      if (query?.kind) q.kind = query.kind;
      if (query?.deterministic_only) q.deterministic_only = true;
      const res = unwrapData(
        await client.get(lookup(chain, address, "links"), {
          query: q,
          signal,
          cacheTtlMs: 0
        })
      );
      const items = Array.isArray(res?.items) ? res.items : [];
      return {
        items,
        next_cursor: res?.next_cursor ?? null,
        node_id: res?.node_id ?? "",
        // Defaults FALSE: claiming a partial list is complete would present a
        // truncated evidence trail as the whole of it.
        complete: res?.complete ?? false,
        profile: profileOf(res?.profile),
        analysis: analysisOf(res?.analysis)
      };
    },
    async requestRun(input) {
      const body = { address: input.address };
      if (input.chain_id) body.chain_id = input.chain_id;
      if (input.chain_ids?.length) body.chain_ids = input.chain_ids;
      if (typeof input.max_hops === "number") body.max_hops = input.max_hops;
      if (input.force) body.force = true;
      if (input.resume_run_id) body.resume_run_id = input.resume_run_id;
      if (input.contract_relationships) body.contract_relationships = input.contract_relationships;
      const res = unwrapData(await client.post(clusters, body));
      return {
        run: res?.run,
        reused: Boolean(res?.reused),
        // Defaults TRUE when the reply is misshaped: a caller that thinks nothing
        // was queued stops polling and never sees the answer it paid for.
        queued: res?.queued ?? true,
        lane: res?.lane ?? null,
        profile: profileOf(res?.profile)
      };
    },
    async listOverrides(signal) {
      const res = unwrapData(
        await client.get(overrides, {
          signal,
          // Never cached: this list is the audit surface for a control that
          // changes results, and a stale one hides a correction somebody just
          // made — or shows one they just withdrew.
          cacheTtlMs: 0
        })
      );
      return {
        overrides: Array.isArray(res?.overrides) ? res.overrides : [],
        count: res?.count ?? res?.overrides?.length ?? 0
      };
    },
    async putOverride(input) {
      const body = {
        action: input.action,
        chain_id: input.chain_id,
        address: input.address,
        reason: input.reason
      };
      if (overrideNeedsPeer(input.action) && input.peer_address) {
        body.peer_address = input.peer_address;
        if (input.peer_chain_id) body.peer_chain_id = input.peer_chain_id;
      }
      if (input.scope) body.scope = input.scope;
      if (input.scope === "team" && input.team_id) body.team_id = input.team_id;
      if (input.replaces) body.replaces = input.replaces;
      if (input.expected_updated_at !== void 0) body.expected_updated_at = input.expected_updated_at;
      const res = unwrapData(
        await client.post(overrides, body)
      );
      if (!res?.override) {
        throw new Error("The service did not return the saved correction.");
      }
      return {
        override: res.override,
        created: res.created ?? true,
        replaced: res.replaced ?? null,
        analysis_queued: typeof res.analysis_queued === "string" ? res.analysis_queued : null
      };
    },
    async deleteOverride(overrideSk) {
      const res = unwrapData(
        await client.delete(
          `${overrides}/${encodePathSegment(overrideSk)}`
        )
      );
      return Boolean(res?.deleted);
    },
    async listRuns(query, signal) {
      if (!query?.address || !query?.chain) {
        throw new Error("Runs are listed per address: pass both address and chain.");
      }
      const q = {
        address: query.address,
        chain: query.chain,
        limit: clampLimit(query.limit)
      };
      if (query.status) q.status = query.status;
      const page = unwrapData(await client.get(runs, { query: q, signal, cacheTtlMs: 0 }));
      return {
        items: Array.isArray(page?.items) ? page.items : [],
        next_cursor: page?.next_cursor ?? null,
        profile: profileOf(page?.profile)
      };
    },
    async getRun(runId, signal) {
      const res = unwrapData(
        await client.get(`${runs}/${encodeURIComponent(runId)}`, {
          signal,
          // Never cached: this is the poll target, and a cached status is a UI
          // that waits forever on a run that finished.
          cacheTtlMs: 0
        })
      );
      return {
        run: res?.run,
        cluster: res?.cluster ?? null,
        profile: profileOf(res?.profile)
      };
    },
    pollRun(runId, signal) {
      return api.getRun(runId, signal);
    }
  };
  return api;
}

// src/related-addresses/members.ts
function memberRowId(row) {
  return row.nodeId || `${row.chainId}#${row.address}`;
}
function linkKindLabel(kind) {
  if (kind === "likely_common_control") return "common-control hypothesis";
  if (kind === "cardano_shared_payment_credential") return "shared payment credential";
  if (kind === "cardano_shared_stake_credential") return "shared stake credential";
  if (kind === "contract_state_reference") return "contract reference";
  if (kind === "utxo_co_spend") return "shared transaction inputs";
  if (kind === "utxo_change_candidate") return "possible change output";
  if (kind === "solana_ata_owner") return "token account ownership";
  if (kind === "factory_creation") return "created through a factory";
  if (kind === "atomic_swap") return "traded in a single transaction";
  if (kind === "manual_link") return "pinned by a correction";
  return kind.replace(/[_-]+/g, " ").trim() || "link";
}
function rejectionLabel(reason) {
  switch (reason) {
    case "no_endorsement":
      return "no rule endorsed it";
    case "below_link_floor":
      return "below the confidence floor";
    case "bidirectionality":
      return "value moved one way only";
    case "suppressed":
      return "vetoed by another signal";
    case "partner_ceiling":
      return "one side trades with too many addresses";
    case "disabled_signal":
      return "its rule is switched off";
    case "expired":
      return "the attestation had expired";
    case "revoked":
      return "the attestation was revoked";
    case "stale_evidence":
      return "the attestation is too old";
    case "future_evidence":
      return "dated in the future";
    case "unfinalized_identity":
      return "not finalised on chain";
    default:
      return (reason ?? "").replace(/[_-]+/g, " ").trim() || "refused";
  }
}
function evidenceLabel(link) {
  if (link.kind === "contract_state_reference" && link.description) return link.description;
  const kind = (link.kind ?? "").trim();
  let known = kind && kind !== "unknown" ? linkKindLabel(kind) : "";
  if (kind === "likely_common_control") {
    const labels = {
      likely: "likely",
      candidate: "candidate",
      contested: "contested",
      expired: "expired",
      retracted: "retracted",
      not_yet_valid: "not yet valid",
      invalid: "invalid"
    };
    const status = typeof link.hypothesis_status === "string" && Object.hasOwn(labels, link.hypothesis_status) ? labels[link.hypothesis_status] : "unvalidated";
    known = `${known} \xB7 ${status}`;
  }
  if (!link.rejection_reason) return known || linkKindLabel(kind);
  const why = rejectionLabel(link.rejection_reason);
  return known ? `${known} \xB7 ${why}` : why;
}
function toMemberRows(members, links, actorNodes, actorMembers = []) {
  const byNode = /* @__PURE__ */ new Map();
  const add = (nodeId, link) => {
    if (!nodeId) return;
    const list = byNode.get(nodeId);
    if (list) list.push(link);
    else byNode.set(nodeId, [link]);
  };
  for (const link of (links ?? []).filter(isAdmittedLink)) {
    add(link.a_id, link);
    add(link.b_id, link);
  }
  const whyFor = (nodeId) => [...byNode.get(nodeId) ?? []].sort(
    (a, b) => (b.confidence ?? 0) - (a.confidence ?? 0)
  );
  const rows = members.map((member) => ({
    nodeId: member.node_id,
    address: member.address,
    chainId: member.chain_id,
    // The generated schema widens the closed enum to `any`; the cast is where
    // the wire's `"seed" | "member"` becomes the type the cells switch on.
    role: member.role,
    confidence: member.confidence ?? 0,
    linkKinds: [...member.link_kinds ?? []],
    why: whyFor(member.node_id),
    tie: !actorNodes ? "unknown" : actorNodes.has(member.node_id) ? "same-actor" : "related"
  }));
  const seen = new Set(rows.map((row) => row.nodeId));
  for (const member of actorMembers) {
    if (!member.node_id || seen.has(member.node_id)) continue;
    seen.add(member.node_id);
    rows.push({
      nodeId: member.node_id,
      address: member.address,
      chainId: member.chain_id,
      role: "member",
      confidence: member.confidence ?? 0,
      linkKinds: [...member.join_kinds ?? []],
      why: whyFor(member.node_id),
      tie: "same-actor"
    });
  }
  return rows;
}

// src/related-addresses/activity.ts
function relationshipActivity(link) {
  const activity = link.activity;
  if (!activity) return void 0;
  return { ...activity, observations: activity.observations ?? [], forwarding: activity.forwarding ?? [] };
}
var DEFAULT_ACTIVITY_FILTER = Object.freeze({ includeUnknown: false });
function activityFilterActive(filter = {}) {
  return filter.from != null || filter.to != null || filter.hourFrom != null || filter.hourTo != null || !!filter.forwardingOnly;
}
function activityFilterError(filter) {
  if ([filter.from, filter.to].some((n) => n != null && (!Number.isFinite(n) || n <= 0))) return "Enter a valid UTC date range.";
  if (filter.from != null && filter.to != null && filter.from > filter.to) return "Start must be before end.";
  if ([filter.hourFrom, filter.hourTo].some((n) => n != null && (!Number.isInteger(n) || n < 0 || n > 23))) return "Hours must be between 00 and 23 UTC.";
  return void 0;
}
function activityTimeMatches(timestamp, filter) {
  if (!Number.isFinite(timestamp) || timestamp <= 0 || activityFilterError(filter)) return false;
  if (filter.from != null && timestamp < filter.from) return false;
  if (filter.to != null && timestamp > filter.to) return false;
  const hour = Math.floor(timestamp / 3600) % 24;
  const start = filter.hourFrom ?? 0, end = filter.hourTo ?? 24;
  return start <= end ? hour >= start && hour < end : hour >= start || hour < end;
}
function matchingForwarding(link, filter = {}) {
  return (relationshipActivity(link)?.forwarding ?? []).filter((p) => activityTimeMatches(p.received_at, filter) && activityTimeMatches(p.sent_at, filter));
}
function activityMatches(link, filter = {}) {
  if (!activityFilterActive(filter)) return true;
  if (activityFilterError(filter)) return false;
  if (filter.forwardingOnly) return matchingForwarding(link, filter).length > 0;
  const activity = relationshipActivity(link);
  if (activity?.observations.some((point) => activityTimeMatches(point.timestamp, filter))) return true;
  return !!filter.includeUnknown && (!activity || activity.undated_count > 0 || activity.truncated || activity.dated_count === 0);
}
function activitySummary(links, filter = {}) {
  const timestamps = /* @__PURE__ */ new Map();
  const forwards = /* @__PURE__ */ new Set();
  let unknownLinks = 0, truncatedLinks = 0;
  for (const link of links) {
    const activity = relationshipActivity(link);
    if (!activity || activity.undated_count > 0 || activity.dated_count === 0) unknownLinks++;
    if (activity?.truncated) truncatedLinks++;
    for (const p of activity?.observations ?? []) if (activityTimeMatches(p.timestamp, filter)) timestamps.set(p.tx_id, p.timestamp);
    for (const p of matchingForwarding(link, filter)) forwards.add(JSON.stringify([p.via_id, p.asset_id, p.incoming_tx_id, p.outgoing_tx_id]));
  }
  const hours = Array(24).fill(0);
  for (const timestamp of timestamps.values()) {
    const hour = Math.floor(timestamp / 3600) % 24;
    hours[hour] = (hours[hour] ?? 0) + 1;
  }
  const dates = [...timestamps.values()].sort((a, b) => a - b);
  return { count: timestamps.size, hours, first: dates[0], last: dates.at(-1), unknownLinks, truncatedLinks, forwardingCount: forwards.size };
}
function activityDate(timestamp) {
  return timestamp ? new Date(timestamp * 1e3).toISOString().replace("T", " ").slice(0, 19) + " UTC" : "Unknown";
}
function activityRangeLabel(activity) {
  if (!activity?.dated_count) return "Timing unknown";
  return `${activityDate(activity.first_seen)} \u2014 ${activityDate(activity.last_seen)}`;
}

// src/related-addresses/presentation.ts
var RELATED_ADDRESS_GRAPH_LIMITS = { nodes: 12, edges: 24 };
var RELATIONSHIP_CLAIM_LABELS = {
  identity: "Identity evidence",
  related: "Related only",
  candidate: "Unverified candidate",
  rejected: "Rejected claim",
  provisional: "Pending / predicted"
};
function pairKey(source, target) {
  return source < target ? `${source}\0${target}` : `${target}\0${source}`;
}
function relationshipRowId(sortKey, occurrence) {
  return `rel-${keys.contentHash(sortKey)}-${occurrence}`;
}
function relatedAddressNodeId(chain, address) {
  const canonical = toCanonicalChainId(chain) ?? chain;
  return `${canonical}#${normalizeAddress(address, canonical)}`;
}
function buildRelatedAddressView(input) {
  const nodes = /* @__PURE__ */ new Map();
  const seedId = relatedAddressNodeId(input.chainId, input.address);
  const add = (chainId, address) => {
    const id = relatedAddressNodeId(chainId, address);
    const existing = nodes.get(id);
    if (existing) return existing;
    const node = {
      id,
      address: normalizeAddress(address, chainId),
      chainId: toCanonicalChainId(chainId) ?? chainId,
      isSeed: id === seedId,
      membership: "unconfirmed"
    };
    nodes.set(id, node);
    return node;
  };
  add(input.chainId, input.address);
  for (const member of input.members ?? []) {
    const node = add(member.chainId, member.address);
    node.membership = member.tie === "same-actor" ? "same-actor" : "snapshot";
  }
  const asOf = input.asOf ?? Date.now() / 1e3;
  const currentLinks = input.links.map((link) => expirePreview(link, asOf));
  const split = splitLinksByClaim(expandContractLinks(currentLinks));
  const claims = [
    ["identity", split.sameActor],
    ["related", split.related.filter((link) => !isCandidateContractReference(link))],
    ["candidate", split.related.filter(isCandidateContractReference)],
    ["rejected", split.rejected.filter((link) => !isProvisionalRelationship(link))],
    ["provisional", split.rejected.filter(isProvisionalRelationship)]
  ];
  const relationships = [];
  const occurrences = /* @__PURE__ */ new Map();
  for (const [claim, links] of claims) {
    for (const link of links) {
      const source = add(link.a_chain_id, link.a_address).id;
      const target = add(link.b_chain_id, link.b_address).id;
      const observationIds = contractObservations(link).map((fact) => fact.observation_id);
      const sortKey = JSON.stringify([source, target, link.kind, claim, link.tx_hash ?? "", observationIds, link.description ?? "", link.rejection_reason ?? ""]);
      const occurrence = occurrences.get(sortKey) ?? 0;
      occurrences.set(sortKey, occurrence + 1);
      relationships.push({
        id: relationshipRowId(sortKey, occurrence),
        sortKey,
        source,
        target,
        claim,
        link,
        // Filled below: it depends on rows that may not exist yet.
        pairAlsoAccepted: false
      });
    }
  }
  const acceptedPairs = new Set(
    relationships.filter((row) => row.claim === "identity" || row.claim === "related").map((row) => pairKey(row.source, row.target))
  );
  for (const row of relationships) {
    if (row.claim === "rejected" && acceptedPairs.has(pairKey(row.source, row.target))) {
      row.pairAlsoAccepted = true;
    }
  }
  relationships.sort((a, b) => (b.link.confidence ?? 0) - (a.link.confidence ?? 0) || a.sortKey.localeCompare(b.sortKey));
  return { seedId, nodes: [...nodes.values()], relationships, movementEvidence: input.movementEvidence };
}
function filterRelatedAddressView(view, filter, query, minimumConfidence = 0, evidenceType = "all", activityFilter = {}) {
  const threshold = Number.isFinite(minimumConfidence) ? Math.max(0, Math.min(1, minimumConfidence)) : 0;
  const needle = query.trim().toLowerCase();
  const matchesNode = (node) => `${node.address} ${node.chainId} ${chainDisplayName(node.chainId)}`.toLowerCase().includes(needle);
  const matchingNodes = new Set(view.nodes.filter(matchesNode).map((node) => node.id));
  const relationships = view.relationships.filter((row) => {
    if (!activityMatches(row.link, activityFilter)) return false;
    if (evidenceType.startsWith("contract") && row.link.kind !== "contract_state_reference") return false;
    if (evidenceType === "contract-observed" && !contractObservations(row.link).some((fact) => fact.assurance === "observed")) return false;
    if (evidenceType === "other" && row.link.kind === "contract_state_reference") return false;
    if (threshold > 0 && (coerceConfidence(row.link.confidence) ?? -1) < threshold) return false;
    if (filter !== "all" && (filter === "accepted" ? row.claim !== "identity" && row.claim !== "related" : row.claim !== filter)) return false;
    return !needle || matchingNodes.has(row.source) || matchingNodes.has(row.target) || `${evidenceLabel(row.link)} ${row.link.description ?? ""} ${row.link.tx_hash ?? ""} ${row.link.rejection_reason ?? ""}`.toLowerCase().includes(needle);
  });
  const visible = new Set(relationships.flatMap((row) => [row.source, row.target]));
  if (relationships.length > 0) visible.add(view.seedId);
  if (filter === "accepted" && threshold === 0 && evidenceType === "all" && !activityFilterActive(activityFilter)) {
    for (const node of view.nodes) {
      if ((node.isSeed || node.membership !== "unconfirmed") && (!needle || matchesNode(node))) visible.add(node.id);
    }
  }
  return { seedId: view.seedId, relationships, nodes: view.nodes.filter((node) => visible.has(node.id)) };
}
function isProvisionalRelationship(link) {
  return link.rejection_reason === "provisional_evidence";
}
function relationshipLifecycle(link) {
  const proof = link.seed_evidence;
  const state = typeof proof?.finality === "string" ? proof.finality : void 0;
  if (!state) return void 0;
  return { state, expiresAt: typeof proof?.valid_until === "number" ? proof.valid_until : void 0 };
}
function expireRelatedAddressPreviews(view, asOf) {
  return { ...view, relationships: view.relationships.map((row) => {
    const link = expirePreview(row.link, asOf);
    return row.claim === "provisional" && link !== row.link ? { ...row, claim: "rejected", link } : row;
  }) };
}
function expirePreview(link, asOf) {
  const expiry = relationshipLifecycle(link)?.expiresAt;
  return isProvisionalRelationship(link) && expiry !== void 0 && expiry <= asOf ? { ...link, rejection_reason: "expired", same_actor: false } : link;
}

// src/related-addresses/strength.ts
var STRENGTH_LABEL = "Strength";
var STRENGTH_EXPLAINER = "An evidence strength, not a probability. It ranks how firmly the recorded evidence ties addresses together and is not calibrated against outcomes: 70% does not mean a 70% chance.";
function formatStrength(score) {
  const pct = formatConfidence(score);
  return pct ? `strength ${pct}` : "";
}
function weakestLinkOf(row) {
  const raw = row?.weakest_link;
  if (!raw || typeof raw !== "object") return null;
  const link = raw;
  const aId = typeof link.a_id === "string" ? link.a_id : "";
  const bId = typeof link.b_id === "string" ? link.b_id : "";
  const confidence = typeof link.confidence === "number" ? link.confidence : NaN;
  if (!aId || !bId || !Number.isFinite(confidence)) return null;
  return { aId, bId, kind: typeof link.kind === "string" ? link.kind : "", confidence };
}
function strOrNull(value) {
  return typeof value === "string" && value ? value : null;
}
function num(value) {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}
function provenanceOf(run, actor) {
  const r = run ?? {};
  const a = actor ?? {};
  const runPolicy = strOrNull(r.policy_fingerprint);
  const actorPolicy = strOrNull(a.policy_fingerprint);
  const out = {
    runId: strOrNull(r.run_id) ?? strOrNull(a.run_id),
    policy: runPolicy ?? actorPolicy,
    engine: strOrNull(r.engine_version) ?? strOrNull(a.engine_version),
    finishedAt: num(r.finished_at) ?? num(a.updated_at),
    requestedBy: strOrNull(r.requested_by),
    identityOnOlderPolicy: Boolean(runPolicy && actorPolicy && runPolicy !== actorPolicy)
  };
  return out.runId || out.policy ? out : null;
}
function shortFingerprint(fingerprint) {
  return fingerprint ? fingerprint.slice(0, 8) : "";
}
function strengthViewOptions(cutoffs) {
  return [
    { view: "any", min: 0, label: "any strength" },
    { view: "medium", min: cutoffs.medium, label: `medium strength or above (\u2265 ${formatConfidence(cutoffs.medium)})` },
    { view: "high", min: cutoffs.high, label: `high strength only (\u2265 ${formatConfidence(cutoffs.high)})` }
  ];
}
function strengthViewMin(view, cutoffs) {
  return strengthViewOptions(cutoffs).find((option) => option.view === view)?.min ?? 0;
}
function filterByStrength(rows, min) {
  if (!(min > 0)) return { shown: [...rows], hidden: 0 };
  const shown = rows.filter((row) => (row.confidence ?? 0) >= min);
  return { shown, hidden: rows.length - shown.length };
}
function clusteringAttributionReason(input) {
  const parts = ["Selected from address clustering"];
  if (input.actorId) parts.push(`identity ${input.actorId}`);
  if (input.provenance?.runId) parts.push(`run ${input.provenance.runId}`);
  if (input.provenance?.policy) parts.push(`policy ${shortFingerprint(input.provenance.policy)}`);
  if (input.provenance?.engine) parts.push(`engine ${input.provenance.engine}`);
  const finite = input.strengths.filter((s) => Number.isFinite(s));
  if (finite.length > 0) {
    const lo = Math.min(...finite);
    const hi = Math.max(...finite);
    parts.push(
      lo === hi ? `strength ${formatConfidence(lo)}` : `strength ${formatConfidence(lo)}\u2013${formatConfidence(hi)}`
    );
  }
  return `${parts.join(" \xB7 ")}.`;
}

// src/related-addresses/caseReferences.ts
function accountParts(account) {
  const parsed = parseAddressReference(account);
  if (!parsed.chain) return null;
  const chainId = toCanonicalChainId(parsed.chain) ?? parsed.chain;
  const address = parsed.address;
  return chainId.includes(":") && address ? { chainId, address } : null;
}
function caseAddressSeed(account) {
  const parsed = accountParts(account);
  if (!parsed || parsed.chainId.endsWith(":*") || !isValidAddress(parsed.address, parsed.chainId)) return void 0;
  const address = normalizeAddress(parsed.address, parsed.chainId);
  return { ...parsed, address, id: relatedAddressNodeId(parsed.chainId, address) };
}
function addressWatchMatches(watch, address, chain) {
  if (watch.kind !== "address" || !watch.account) return false;
  const account = accountParts(watch.account);
  const chainId = toCanonicalChainId(chain) ?? chain;
  if (!account || account.chainId.split(":")[0] !== chainId.split(":")[0]) return false;
  if (normalizeAddress(account.address, chainId) !== normalizeAddress(address, chainId)) return false;
  return !watch.chains?.length || watch.chains.some((scope) => {
    const canonical = toCanonicalChainId(scope) ?? scope;
    return canonical === chainId || canonical === `${chainId.split(":")[0]}:*`;
  });
}
function caseAddressSeeds(watches) {
  const seeds = /* @__PURE__ */ new Map();
  for (const watch of watches) {
    if (watch.kind !== "address" || !watch.account) continue;
    const account = accountParts(watch.account);
    if (!account) continue;
    const scopes = watch.chains?.length ? watch.chains : [account.chainId];
    for (const scope of scopes) {
      const canonical = toCanonicalChainId(scope) ?? scope;
      const chainId = canonical.endsWith(":*") ? account.chainId : canonical;
      if (chainId.endsWith(":*") || !addressWatchMatches(watch, account.address, chainId) || !isValidAddress(account.address, chainId)) continue;
      const address = normalizeAddress(account.address, chainId);
      const id = relatedAddressNodeId(chainId, address);
      seeds.set(id, { id, address, chainId });
    }
  }
  return [...seeds.values()];
}
var ProofSchema = z.object({ metadata: z.object({
  verification: z.literal("pinned_receipt_event"),
  chain_id: z.string(),
  tx_hash: z.string().regex(/^0x[0-9a-fA-F]{64}$/),
  block_number: z.number().int().nonnegative(),
  block_hash: z.string().regex(/^0x[0-9a-fA-F]{64}$/),
  message_id: z.string(),
  role: z.enum(["source", "destination"]),
  receipt_status: z.literal("success"),
  definition_hash: z.string(),
  logs: z.array(z.object({ address: z.string(), log_index: z.union([z.string(), z.number()]).nullish(), event: z.string().optional() })).min(1)
}) });
function bridgeReceiptEvidence(link) {
  if (link.kind !== "bridge_correlation") return [];
  const values = link.values;
  return ["source", "destination"].flatMap((role) => {
    const rows = values?.[`${role}_evidence`];
    if (!Array.isArray(rows)) return [];
    return rows.flatMap((row) => {
      const parsed = ProofSchema.safeParse(row);
      if (!parsed.success || parsed.data.metadata.role !== role || parsed.data.metadata.message_id !== values?.id_value) return [];
      return [parsed.data.metadata];
    });
  });
}

// src/related-addresses/execution.ts
function movementProofs(link) {
  const unique = /* @__PURE__ */ new Map();
  for (const edge of link.flow_edges ?? []) {
    for (const proof of edge.movement_evidence ?? []) {
      if (proof?.observation?.id && proof?.binding?.state) unique.set(proof.observation.id, proof);
    }
  }
  return [...unique.values()];
}
function isMovementLink(link) {
  return link.kind === "observed_movement" || link.kind === "economic_attribution";
}
function executionPerspective(view, perspective) {
  if (perspective === "relationships") {
    const relationships = view.relationships.filter((row) => !isMovementLink(row.link));
    const ids = new Set(relationships.flatMap((row) => [row.source, row.target]));
    return { ...view, relationships, nodes: view.nodes.filter((n) => n.isSeed || ids.has(n.id)) };
  }
  if (perspective === "ownership") {
    const relationships = view.relationships.filter((row) => row.claim === "identity");
    const ids = new Set(relationships.flatMap((row) => [row.source, row.target]));
    return { ...view, relationships, nodes: view.nodes.filter((n) => n.isSeed || ids.has(n.id)) };
  }
  const links = /* @__PURE__ */ new Map();
  const sources = [
    ...view.relationships.map((row) => ({ link: row.link, proofs: movementProofs(row.link) })),
    { link: RelatedAddressLinkRowSchema.parse({}), proofs: view.movementEvidence ?? [] }
  ];
  for (const source of sources) {
    for (const proof of source.proofs) {
      const fact = proof.observation;
      const economic = perspective === "economic";
      if (economic && (proof.attribution?.state !== "resolved" || !proof.attribution.actor)) continue;
      const sender = economic ? proof.attribution.actor : fact.from_address;
      if (!sender || !fact.to_address || !fact.chain_id) continue;
      links.set(fact.id, {
        ...source.link,
        id: fact.id,
        a_id: `${fact.chain_id}#${sender}`,
        b_id: `${fact.chain_id}#${fact.to_address}`,
        a_address: sender,
        b_address: fact.to_address,
        a_chain_id: fact.chain_id,
        b_chain_id: fact.chain_id,
        kind: economic ? "economic_attribution" : "observed_movement",
        same_actor: false,
        deterministic: true,
        rejection_reason: null,
        cluster_id: null,
        confidence: 1,
        tx_count: 1,
        tx_hash: fact.tx_id,
        description: `${economic ? "Attributed" : "Observed"} movement of ${economic ? proof.attribution?.output?.amount_raw ?? fact.amount_raw : fact.amount_raw} raw units. This is not ownership evidence.`,
        values: { movement_id: fact.id },
        seed_evidence: {},
        activity: RelationshipActivitySchema.parse(fact.timestamp && fact.tx_id ? {
          first_seen: fact.timestamp,
          last_seen: fact.timestamp,
          dated_count: 1,
          observations: [{ tx_id: `${fact.chain_id}:${fact.tx_id}`, timestamp: fact.timestamp }]
        } : { undated_count: 1 }),
        evidence: [],
        explanation: [],
        flow_edges: [GraphEdgeSchema.parse({
          from_id: `${fact.chain_id}#${sender}`,
          to_id: `${fact.chain_id}#${fact.to_address}`,
          from_chain: fact.chain_id,
          to_chain: fact.chain_id,
          movement_evidence: [proof]
        })]
      });
    }
  }
  const seed = view.nodes.find((n) => n.id === view.seedId);
  if (!seed) return { ...view, relationships: [] };
  return buildRelatedAddressView({ address: seed.address, chainId: seed.chainId, links: [...links.values()] });
}

export { CLUSTER_ANALYSIS_PROFILES, CLUSTER_ANALYSIS_PROFILE_LABELS, CLUSTER_DEFAULT_PAGE_LIMIT, CLUSTER_MAX_HOPS_CEILING, CLUSTER_MAX_PAGE_LIMIT, CLUSTER_MEMBER_ROLES, CLUSTER_OVERRIDE_ACTIONS, CLUSTER_OVERRIDE_ACTION_LABELS, CLUSTER_OVERRIDE_AUTHORING_SCOPES, CLUSTER_OVERRIDE_SCOPES, CLUSTER_OVERRIDE_SCOPE_LABELS, CLUSTER_OVERRIDE_SCOPE_RANK, CLUSTER_PEER_OVERRIDE_ACTIONS, CLUSTER_RUN_REUSE_WINDOW_SECONDS, CLUSTER_RUN_STATUSES, CLUSTER_RUN_STATUS_LABELS, CLUSTER_RUN_TRIGGERS, DEFAULT_ACTIVITY_FILTER, DEFAULT_CLUSTER_MAX_HOPS, LOOKUP_CHUNK_ACCOUNTS, LOOKUP_CHUNK_CONCURRENCY, MANUAL_LINK_KIND, MAX_IDENTITY_ACCOUNTS, MAX_LOOKUP_ACCOUNTS, RELATED_ADDRESS_GRAPH_LIMITS, RELATED_ADDRESS_SCOPES, RELATIONSHIP_CLAIM_LABELS, STRENGTH_EXPLAINER, STRENGTH_LABEL, TERMINAL_CLUSTER_RUN_STATUSES, activityDate, activityFilterActive, activityFilterError, activityMatches, activityRangeLabel, activitySummary, activityTimeMatches, addressClusterState, addressWatchMatches, bridgeReceiptEvidence, buildRelatedAddressView, caseAddressSeed, caseAddressSeeds, clusterAnalysisProfileLabel, clusterRunAnswered, clusterRunReplacesAnswer, clusteringAttributionReason, createRelatedAddressesApi, effectiveOverride, encodePathSegment, evidenceLabel, executionPerspective, expireRelatedAddressPreviews, filterByStrength, filterRelatedAddressView, formatStrength, isAdmittedLink, isAppliedOverrideScope, isIdentityClaim, isLiveActor, isMovementLink, isProvisionalRelationship, isTerminalClusterRunStatus, linkCounterpart, linkKindLabel, matchingForwarding, memberRowId, mergeRoleCompositions, movementProofs, overrideNeedsCluster, overrideNeedsPeer, provenanceOf, rejectionLabel, relatedAddressNodeId, relationshipActivity, relationshipLifecycle, shortFingerprint, splitLinksByClaim, strengthViewMin, strengthViewOptions, toMemberRows, viewCorrections, weakestLinkOf };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map